import WmsProvider from "./wms";
import AuthProvider from "./auth";
import UserProvider from "./user";
import OrderProvider from "./order";
import ProductProvider from "./product";
import ProductCategoryProvider from "./product_category";
import ReportProvider from "./report";
import PackingProvider from "./packing";
import CustomerProvider from "./customer";
import TiktokProvider from "./platform_tiktok";
import ShopeeProvider from "./platform_shopee";
import LazadaProvider from "./platform_lazada";
import PlatformProvider from "./platform";
import LineProvider from "./platform_line";
import PaymentMethodProvider from "./payment_method";
import SaleChannelProvider from "./sale_channel";
import TeamProvider from "./team";
import DepartmentProvider from "./department";
import CouponProvider from "./coupon";
import POProvider from "./po";
import MemberProvider from "./member";
import PlatformStatementProvider from "./platform_statement";

const WmsService = new WmsProvider();
const AuthService = new AuthProvider();
const UserService = new UserProvider();
const OrderService = new OrderProvider();
const ProductService = new ProductProvider();
const ProductCategoryService = new ProductCategoryProvider();
const ReportService = new ReportProvider();
const PackingService = new PackingProvider();
const CustomerService = new CustomerProvider();
const TiktokService = new TiktokProvider();
const ShopeeService = new ShopeeProvider();
const LazadaService = new LazadaProvider();
const PlatformService = new PlatformProvider();
const LineService = new LineProvider();
const PaymentMethodService = new PaymentMethodProvider();
const SaleChannelService = new SaleChannelProvider();
const TeamService = new TeamProvider();
const DepartmentService = new DepartmentProvider();
const CouponService = new CouponProvider();
const POService = new POProvider();
const MemberService = new MemberProvider();
const PlatformStatementService = new PlatformStatementProvider();

export {
    WmsService,
    AuthService,
    UserService,
    OrderService,
    ProductService,
	ProductCategoryService,
    ReportService,
    PackingService,
    CustomerService,
    TiktokService,
    ShopeeService,
    LazadaService,
	PlatformService,
    LineService,
	PaymentMethodService,
	SaleChannelService,
	TeamService,
	DepartmentService,
	CouponService,
    POService,
    MemberService,
    PlatformStatementService
};
